import React from 'react';
import {
  SignalIcon,
  ClockIcon,
  ExclamationTriangleIcon,
  CheckCircleIcon,
  ArrowPathIcon
} from '@heroicons/react/24/outline';

const DeviceStatusBadge = ({ status, isOnline, showLabel = true }) => {
  const getStatusConfig = () => {
    if (status === 'syncing') {
      return {
        icon: <ArrowPathIcon className="w-4 h-4 animate-spin" />,
        label: 'Syncing',
        colorClass: 'text-blue-600 bg-blue-50',
        borderClass: 'border-blue-200'
      };
    }

    if (isOnline) {
      return {
        icon: <SignalIcon className="w-4 h-4" />,
        label: 'Online',
        colorClass: 'text-green-600 bg-green-50',
        borderClass: 'border-green-200'
      };
    }

    // Offline states
    switch (status) {
      case 'pending_sync':
        return {
          icon: <ClockIcon className="w-4 h-4" />,
          label: 'Pending Sync',
          colorClass: 'text-blue-600 bg-blue-50',
          borderClass: 'border-blue-200'
        };

      case 'recently_offline':
        return {
          icon: <SignalIcon className="w-4 h-4" />,
          label: 'Recently Offline',
          colorClass: 'text-yellow-600 bg-yellow-50',
          borderClass: 'border-yellow-200'
        };

      case 'offline':
        return {
          icon: <SignalIcon className="w-4 h-4" />,
          label: 'Offline',
          colorClass: 'text-orange-600 bg-orange-50',
          borderClass: 'border-orange-200'
        };

      case 'long_offline':
        return {
          icon: <ExclamationTriangleIcon className="w-4 h-4" />,
          label: 'Long Offline',
          colorClass: 'text-red-600 bg-red-50',
          borderClass: 'border-red-200'
        };

      case 'stale':
        return {
          icon: <ExclamationTriangleIcon className="w-4 h-4" />,
          label: 'Stale (>7 days)',
          colorClass: 'text-gray-500 bg-gray-50',
          borderClass: 'border-gray-200'
        };

      default:
        return {
          icon: <SignalIcon className="w-4 h-4" />,
          label: 'Unknown',
          colorClass: 'text-gray-600 bg-gray-50',
          borderClass: 'border-gray-200'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium ${config.colorClass} ${config.borderClass} border`}>
      {config.icon}
      {showLabel && <span>{config.label}</span>}
    </div>
  );
};

export default DeviceStatusBadge;